// src/config.js
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const SOCIAL_FRONTEND_URL = process.env.REACT_APP_SOCIAL_FRONTEND_URL;